<template>
  <main>
    <section-hero :bgImg="bgImg"></section-hero>
    <section id="scrollToOnLoad" class="section--agora-project">
      <b-container>
        <b-row v-if="homeContent.title">
          <b-col sm="6" lg="5" xl="6" class="mx-sm-auto mx-md-0 float-right">
            <div class="zoom-on-hover">
              <img class="img-fluid" :src="domain + homeContent.photo.url" alt="">
            </div>
          </b-col>
          <b-col sm="6" lg="7" xl="5" offset-xl="1"
            class="d-flex flex-column justify-content-center">
            <h2 class="mt-4 mt-sm-2 mt-md-0">{{ homeContent.title }}
              <span class="text--shadow-right">{{ homeContent.title }}</span></h2>
            <div v-html="homeContent.small_section"></div>
          </b-col>
          <b-col>
            <p v-html="homeContent.body"></p>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section-figures :figures="figures" isStatic="true" itemColSize="4"></section-figures>
    <section class="section--opinions" v-if="opinion[0]">
      <b-container>
        <b-row>
          <b-col xl="10" offset-xl="1">
            <div class="opinion">
              <p class="opinion__content">{{ opinion[0].quote }}</p>
              <span class="opinion__signature">{{ opinion[0].name }}</span>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="section--news" v-if="newsList.length">
      <b-container>
        <b-row>
          <b-col>
          <carousel
          :perPage="showSlides"
          :autoplay="true" :paginationEnabled="false">
            <slide v-for="(news, index) in newsList" :key="index">
              <div class="news">
                  <img class="img-fluid news__img"
                  :src="domain + `${news.photo}`" alt="">
                <div class="news__content">
                  <h5>{{news.title}}</h5>
                  <p v-if="news.body"
                    v-html="$options.filters.shortContent(news.body, contentLimit)">
                  </p>
                 </div>
               </div>
            </slide>
          </carousel>
          </b-col>
        </b-row>
        <router-link :to="{ name: 'news' }" v-scroll-to="'#scrollToOnLoad'"
          tag="button" class="btn btn-primary btn-sm">
          {{ $t("readMore") }}
        </router-link>
      </b-container>
    </section>
  </main>
</template>

<script>
import homeContent from '@/api/v1/home';
import Hero from '@/components/Hero';
import Figures from '@/components/Figures';
import news from '@/api/v1/news';
import { Carousel, Slide } from 'vue-carousel';
import filters from '@/utils/filters';

export default {
  data() {
    return {
      showSlides: 0,
      bgImg: 'Banner7-Home-',
      newsList: [],
      contentLimit: 90,
      homeContent: {},
      opinion: {},
      domain: process.env.SERVER_URL,
      figures: [
        {
          imgName: 'img_sign-up.jpg',
          title: this.$t('main.logTitle'),
          description: this.$t('main.logDescription'),
          btnText: this.$t('main.logbtnText'),
          routeName: 'login',
        },
        {
          imgName: 'scientistgroup.jpg',
          title: this.$t('main.scientistTitle'),
          description: this.$t('main.scientistDescription'),
          btnText: this.$t('main.scientistBtnText'),
          routeName: 'careers',
        },
        {
          imgName: 'cartoonpuzzle.jpg',
          title: this.$t('main.needToKnowTitle'),
          description: this.$t('main.needToKnowDescription'),
          btnText: this.$t('check'),
          routeName: 'need_to_know/4',
        },
      ],
    };
  },
  components: {
    'section-hero': Hero,
    'section-figures': Figures,
    Carousel,
    Slide,
  },
  methods: {
    slideToShow() {
      this.showSlides = window.innerWidth > 767 ? 3 : 1;
    },
    getNews() {
      const succ = (response) => { this.newsList = response.data.news; };
      news.index(1, succ);
    },
    getContent() {
      const succ = (response) => {
        this.homeContent = response.data.homes;
      };
      homeContent.index(succ);
    },
    getQuoteContent() {
      const succ = (response) => {
        this.opinion = response.data.quotes_home;
      };
      homeContent.getOpinion(succ);
    },
  },
  filters: {
    shortContent: filters.shortContent,
  },
  created() {
    this.getContent();
    this.getQuoteContent();
    this.slideToShow();
    this.getNews();
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/helpers/_variables.scss';
@import '../styles/helpers/_include-media.scss';

.section {
  &--agora-project {
    padding-bottom: 100px;
    padding-top: 100px;
    @include media('<lg') {
      padding: 50px 0;
    }
  }
  &--opinions {
    padding: 165px 0 118px;
    background-color: $color--orange;
    @include media('<lg') {
      padding: 90px 0 50px;
    }
  }
  &--news {
    padding: 100px 0;
    text-align: center;
    @include media('<lg') {
      padding: 50px 0;
    }
  }
  &--figures {
    @include media('<lg') {
      background-color: $color--white-1;
      padding: 50px 0;
    }
  }
}

.opinion {
  text-align: center;
  padding: 0 70px;
  @include media('<lg') {
    padding: 0 20px;
  }
  &__content {
    font-size: 20px;
    font-style: italic;
    font-family: Montserrat;
    color: $color--white;
    position: relative;
    text-align: center;
    margin-bottom: 15px;
    &:before {
      content: url('../assets/ico-quotation-mark.png');
      position: absolute;
      top: -48px;
      transform: translateX(-50%);
      left: 50%;
      @include media('<lg') {
        font-size: 30px;
      }
    }
    @include media('<lg') {
      font-size: 14px;
      margin-bottom: 5px;
    }
  }
  &__signature {
    font-family: Montserrat;
    font-size: 20px;
    font-weight: 600;
    @include media('<lg') {
      font-size: 16px;
    }
  }
}
.news {
  @include media('<lg') {
    margin: 0 5px;
  }
  &__content{
    padding: 20px 22px;
    @include media('<lg') {
      padding-bottom: 0;
    }
  }
  &__img {
    height: 300px;
    width: 360px;
    @include media('<xl') {
      width: 280px;
      height: 230px;
    }
    @include media('<lg') {
      width: 100%;
      height: 160px;
    }
    @include media('<md') {
      height: 170px;
    }
    @include media('<sm') {
      width: 260px;
      height: auto;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Home.vue